<template>
  <div class="clickable" @click="$emit('close')">Go Back</div>
  <div class="team-detail">
    <div class="row">
      <div class="col-12 col-lg-12">
        <span class="text__team-name">
          {{ team.owner.firstName }} {{ team.owner.lastName }}
        </span>
        <span class="text__team-record">
          <!-- todo championship trophy emblems? -->
          <!-- todo emblems for all time records? -->
        </span>
      </div>
    </div>
    <div class="row text--secondary owner-card__attributes">
      <div class="col-12 col-lg-3">
        <owner-card-career-record
          label="Experience"
          :value="team.records.experience"
        />
        <owner-card-career-record
          label="Championships"
          :value="team.records.championshipYears.length"
        />
        <owner-card-career-record
          label="Playoffs"
          :value="team.records.playoffYears.length"
        />
        <owner-card-career-record
          label="Playoff Wins"
          :value="team.records.playoffWins"
        />
      </div>
      <div class="col-12 col-lg-6" style="margin-top: 15px;">
        <div class="row">
          <div class="d-none d-lg-block col-lg-3"></div>
          <div class="d-none d-lg-block col-lg-3 text--secondary">Last 3</div>
          <div class="d-none d-lg-block col-lg-3 text--secondary">Season</div>
          <div class="d-none d-lg-block col-lg-3 text--secondary">All Time</div>
        </div>
        <owner-card-time-record
          class="time-record"
          label="Record"
          :recentData="
            team.records.recentGames.wins +
            ' - ' +
            team.records.recentGames.losses +
            ' - ' +
            team.records.recentGames.ties
          "
          :seasonData="
            team.records.currentSeasonGames.wins +
            ' - ' +
            team.records.currentSeasonGames.losses +
            ' - ' +
            team.records.currentSeasonGames.ties
          "
          :allTimeData="
            team.record.overall.wins +
            ' - ' +
            team.record.overall.losses +
            ' - ' +
            team.record.overall.ties
          "
        />
        <owner-card-time-record
          class="time-record"
          label="Avg Points For"
          :recentData="
            (
              team.records.recentGames.pointsFor /
              team.records.recentGames.matchupCount
            ).toFixed(2) || '---'
          "
          :seasonData="
            (
              team.records.currentSeasonGames.pointsFor /
              team.records.currentSeasonGames.matchupCount
            ).toFixed(2) || '---'
          "
          :allTimeData="team.pointsForAverage"
        />
        <owner-card-time-record
          class="time-record"
          label="Avg Points Against"
          :recentData="
            (
              team.records.recentGames.pointsAgainst /
              team.records.recentGames.matchupCount
            ).toFixed(2) || '---'
          "
          :seasonData="
            (
              team.records.currentSeasonGames.pointsAgainst /
              team.records.currentSeasonGames.matchupCount
            ).toFixed(2) || '---'
          "
          :allTimeData="team.pointsAgainstAverage"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <div class="row text--secondary">
          <div class="d-none d-lg-block col-lg-4">
            Name
          </div>
          <div class="d-none d-lg-block col-lg-2 center-content">
            <div class="row">
              <div class="col-lg-4">
                W
              </div>
              <div class="col-lg-4">
                L
              </div>
              <div class="col-lg-4">
                T
              </div>
            </div>
          </div>
          <div class="d-none d-lg-block col-lg-2 center-content">
            Pct
          </div>
        </div>
        <div
          class="row clickable row--expanded"
          v-for="matchup in team.records.matchupHistory"
          :key="matchup.opponent.id"
          @click="loadMatchupHistory(matchup)"
        >
          <div class="col-12 col-lg-4">
            {{
              matchup.opponent.owner.firstName +
              " " +
              matchup.opponent.owner.lastName
            }}
          </div>
          <div class="col-12 col-lg-2 center-content">
            <div class="row">
              <div class="d-none d-lg-block col-lg-4">{{ matchup.wins }}</div>
              <div class="d-none d-lg-block col-lg-4">{{ matchup.losses }}</div>
              <div class="d-none d-lg-block col-lg-4">{{ matchup.ties }}</div>
              <div class="d-lg-none offset-1 col-4">
                {{ matchup.wins }} - {{matchup.losses}} - {{matchup.ties}}
              </div>
              <div class="d-lg-none col-3">{{(matchup.wins / matchup.results.length).toFixed(3)}}</div>
            </div>
          </div>
          <div class="d-none d-lg-block col-lg-2 center-content">
            {{(matchup.wins / matchup.results.length).toFixed(3)}}
          </div>
        </div>
      </div>
      <!-- todo make this a matchup-detail page -->
      <div class="col-12 col-lg-6" v-if="showMatchupHistory" style="margin-top: 25px;">
        <div class="row text--secondary">
          <div class="col-4 col-lg-2 center-content">
            Week
          </div>
          <div class="col-4 col-lg-3 center-content">
            {{ team.owner.firstName }}
          </div>
          <div class="col-4 col-lg-3 center-content">
            {{ selectedMatchup.opponent.owner.firstName }}
          </div>
        </div>
        <div class="row" v-for="result in selectedMatchup.results" :key="result.week + ' ' + result.year">
          <div class="col-4 col-lg-2">
            {{ result.year }} - {{ result.week }}  
          </div>
          <div class="col-4 col-lg-3 center-content">
            {{ result.ownerScore }}
          </div>
          <div class="col-4 col-lg-3 center-content">
            {{ result.opponentScore }}
          </div>
        </div>
      </div>
      <!-- todo next matchup 
          "tale of the tape" 
          make it expand to the other owner card maybe
          Some sort of chance to win calculator? 
         -->
      <!-- todo records against each opponent -->
    </div>
  </div>
</template>

<script lang="ts">
import { PropType, ref } from "vue";
import OwnerCardCareerRecord from "./OwnerCardCareerRecord.vue";
import OwnerCardTimeRecord from "./OwnerCardTimeRecord.vue";
import Team from "../shared/teams/team";
import orderBy from 'lodash/orderBy';
import Matchup from '@/shared/matchups/matchup';

function useTeamDetail(team: Team) {
  const showMatchupHistory = ref<boolean>(false);
  const selectedMatchup = ref<Matchup>();

  function loadMatchupHistory(matchup: Matchup) {
    matchup.results = orderBy(matchup.results, ['year', 'week'], ['desc', 'desc']);
    showMatchupHistory.value = true;
    selectedMatchup.value = matchup;
  }

  function rowClass(index: number) {//todo make this a useStripedRow import
    if (index % 2 === 0) {
      return "row--striped";
    } else {
      return "row--main";
    }
  }

  if (team.records) {
    team.records.matchupHistory = orderBy(team.records.matchupHistory, matchup => matchup.opponent.owner.firstName, ['asc']);
  }

  return { loadMatchupHistory, rowClass, selectedMatchup, showMatchupHistory };
}

export default {
  components: { OwnerCardCareerRecord, OwnerCardTimeRecord },
  props: {
    team: Object as PropType<Team>,
  },
  emits: {
    close: null,
  },
  setup(props: any) {
    return useTeamDetail(props.team as Team);
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables";
.text__team-name {
  font-size: 1.5rem;
  font-weight: 600;
  color: $color-primary-text;
}

.time-record {
  margin-bottom: 15px;
}

@media screen and (min-width: $width-large) {  
  .team-detail {
    width: 75%;
    margin: 0 auto;
    background-color: $color-secondary-background;
    padding: 20px;
    border-radius: 25px;
    text-align: left;
  }

  .time-record {
    margin-bottom: initial;
  }

  .text__team-name {
    font-size: 28px;
    font-weight: 600;
    color: $color-primary-text;
  }

  .text__team-record {
    margin-left: 1.2rem;
    font-size: 28px;
    color: $color-secondary-text;
  }

  .owner-card {
    &__attributes {
      padding: 0;
    }
  }
}
</style>